export default __webpack_public_path__ + "static/media/BEN.cf121c67.svg";